module.exports = __webpack_public_path__ + "static/img/amz_btn.d75401a.png";


//////////////////
// WEBPACK FOOTER
// ./xcloud-client-components-web/images/common/amz_btn.png
// module id = sVhj
// module chunks = 66